/**
 * Executes callback once scroll ends or if it does not start.
 * Source: https://gomakethings.com/detecting-when-a-visitor-has-stopped-scrolling-with-vanilla-javascript/
 * @param {Function} callback function to execute when scrolling is done or if it is never initiated
 */
export default function(callback) {
    let timeoutId = null;

    const setScrollEnd = function() {
        timeoutId = setTimeout(function () {
            if (callback) {
                callback();
            }
            window.removeEventListener('scroll', checkScrolling);
            window.clearTimeout(timeoutId);
        }, 50);
    }

    setScrollEnd();
    function checkScrolling(event) {
        if (timeoutId) {
            window.clearTimeout(timeoutId);
        }

        setScrollEnd();
    }

    window.addEventListener('scroll', checkScrolling, {passive: true});
}